export const decodeEnDash = (input: string): string =>
  input.replace(/&#8211;/g, "–");
